import * as R from 'ramda';
import { createLogic } from 'redux-logic';
// features
import { sendLogOutRequest } from '../auth/actions';
import { receivedSwitchBranchSuccess } from '../branch/actions';
//
import * as A from './actions';
//////////////////////////////////////////////////

const handleCleanStateActionsLogic = createLogic({
  type: [
    sendLogOutRequest,
    receivedSwitchBranchSuccess,
  ],
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    dispatch(A.cleanReportStateAction());
    done();
  },
});

const handleSetEditDataReportRequest = createLogic({
  type: A.openEditReportModal,
  process({ action }, dispatch, done) {
    const { payload } = action;
    dispatch(payload.modal(R.head(payload.usedReport)));
    done();
  },
});

export default [
  handleCleanStateActionsLogic,
  handleSetEditDataReportRequest,
];
